import React from 'react';
import { DetailsPage } from 'components';
import logoOpenlane from 'assets/images/logo-openlane-dark.svg';


let Pim = () => {
    return (
        <>
            <DetailsPage
                eyebrow="PIM / PXM / DAM"
                title="openlane"
                lead="La piattaforma che riunisce dati, immagini e documenti: il team vede subito cosa manca e tiene aggiornati ecommerce, marketplace, cataloghi e rete vendita."
                watermark
                watermarkSrc={logoOpenlane}
            >
                <>
                    <div className="service-single-contentblock fulwidth">
                        <div className="service-single-contentbox">
                            <p>openlane è la piattaforma PXM (Product Experience Management) pensata per le aziende che sviluppano i propri prodotti. Riunisce <strong>dati, immagini e documenti</strong> in un'unica piattaforma: il team vede subito cosa manca, prepara le schede più in fretta e tiene aggiornati ecommerce, marketplace, cataloghi e rete vendita.</p>

                            <p>Troppo spesso ERP, fogli di calcolo e cartelle condivise non tengono il passo con la crescita di prodotti, varianti, mercati e canali. Le informazioni non coincidono, le lacune emergono solo al momento di pubblicare e ogni nuovo canale aggiunge lavoro manuale. openlane parte da una convinzione diversa: <strong>la tecnologia deve adattarsi alle persone</strong>, ai processi e alle competenze già presenti in azienda.</p>

                            <p>Con openlane il catalogo diventa una <strong>base di lavoro chiara e condivisa</strong>. Si vede a colpo d'occhio quali schede sono complete, quali vanno riviste e quali sono pronte per la pubblicazione. Regole e controlli segnalano dati mancanti o incoerenti prima che arrivino sui canali, così ecommerce, marketplace, cataloghi e rete vendita ricevono le stesse informazioni, adattate a ciò che ciascun canale richiede.</p>

                            <p>La piattaforma si configura intorno ai vostri prodotti e processi, si integra con i sistemi già in uso — ERP, ecommerce, marketplace e altri applicativi — e lascia il team autonomo nel lavoro quotidiano. <strong>La solidità di una piattaforma enterprise, senza il peso di uno strumento difficile da imparare e da far funzionare.</strong></p>

                            <p>Per maggiori informazioni, visita il sito ufficiale: <a href="https://www.openlaneapp.it" target="_blank" rel="noopener"><strong>www.openlaneapp.it</strong></a></p>

                        </div>
                       
                    </div>
                </>
            </DetailsPage>
        </>
    );
}

export default Pim;
